import _ from 'lodash';

export const MyError = {
  UNKNOWN: 'UNKNOWN',
  PROGRAM_NO_SIGNER: 'PROGRAM_NO_SIGNER',
  NOT_MATCH_OPERATOR: 'NOT_MATCH_OPERATOR',
  EXPIRED_NONCE: 'EXPIRED_NONCE',
  INVALID_SIGNER: 'INVALID_SIGNER',
  INVALID_FROGS: 'INVALID_FROGS',
  GAME_WAS_SETTLED: 'GAME_WAS_SETTLED',
  TICKET_NOT_SYNCED: 'Tickets are not synced, please try again in few minutes',
  STAKE_NOT_SYNCED: 'Tickets are not synced, please try again in few minutes',
  INVALID_WINNER: 'INVALID_WINNER',
} as const;

export const getReadableMsg = (err?: string) => {
  return _.get(MyError, [err || ''], _.startCase(err));
};
